import type { ValorantServer } from 'generated/openapi';
import { z } from 'zod';

const valorantServerEnum = z.enum<ValorantServer[]>([
  'US_WEST_OREGON',
  'US_WEST_CALIFORNIA',
  'US_EAST_VIRGINIA',
  'US_CENTRAL_TEXAS',
  'US_CENTRAL_ILLINOIS',
  'US_CENTRAL_GEORGIA',
  'SANTIAGO',
  'MEXICO_CITY',
  'MIAMI',
  'SAO_PAULO',
  'FRANKFURT',
  'PARIS',
  'STOCKHOLM',
  'ISTANBUL',
  'LONDON',
  'WARSAW',
  'MADRID',
  'BAHRAIN',
  'SEOUL',
  'HONG_KONG',
  'TOKYO',
  'SINGAPORE',
  'SYDNEY',
  'MUMBAI',
  'MANILA',
]);

export const serversSchema = z
  .array(valorantServerEnum)
  .min(1, { message: 'Select at least one server' });
